module.exports = __webpack_public_path__ + "img/saomajiesuo.22bee2b1.png";